var $776758c71b57000c$exports = {};
$776758c71b57000c$exports = {
    "backButton": (args)=>`Palaa kohtaan ${args.prevMenuButton}`,
    "moreActions": `Lis\xe4\xe4 toimintoja`,
    "unavailable": `Ei saatavilla, laajenna saadaksesi lis\xe4tietoja`
};


export {$776758c71b57000c$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
